import React from 'react';

import { AccordionItem } from 'src/components/custom';
import { useMenuContext } from './context';
import { Props as AccoridionItemProps } from 'src/components/custom/AccoridionItem';

export type Props = {
  subMenuKey: string | number;
  isActive?: boolean;
  className?: string;
  onClick?: (key: string | number, isActive: boolean) => void;
} & AccoridionItemProps;

const SubMenu: React.FC<Props> = (props) => {
  const { subMenuKey, onClick, className, title, content, ...rest } = props;

  const { openKeys = [] } = useMenuContext();

  return (
    <AccordionItem
      border={false}
      className={className}
      itemKey={subMenuKey}
      title={title}
      content={content}
      isActive={openKeys.includes(subMenuKey)}
      onTitleClick={(key) => onClick?.(key, openKeys.includes(subMenuKey))}
      {...rest}
    />
  );
};

export default SubMenu;
